import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';
class DVCFileC202API extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCFileC202s';
}
export default new DVCFileC202API();
